import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import ImperativeTooltip from "../atoms/Tooltip/ImperativeTooltip";

const TruncatedText = ({ truncatedText, originalText }) => {
  const [isOpen, setIsOpen] = useState(false);
  const itemRef = useRef(null);

  return (
    <span>
      <span
        onClick={() => setIsOpen(true)}
        className="truncated-text"
        data-tooltip={isOpen ? null : "Click to view full text"}
        ref={itemRef}
      >
        {truncatedText}
      </span>
      {isOpen && (
        <ImperativeTooltip
          anchor={itemRef.current}
          onClose={() => setIsOpen(false)}
          ContentRenderer={() => <div>{originalText}</div>}
          contentClassName="tw-break-words"
        />
      )}
    </span>
  );
};

TruncatedText.propTypes = {
  truncatedText: PropTypes.string,
  originalText: PropTypes.string,
};

TruncatedText.defaultProps = {
  truncatedText: null,
  originalText: null,
};

export default React.memo(TruncatedText);
